import { Injectable } from '@angular/core';
import { NgrxHttpClient } from '@library/utils/services/http-service';
import { Observable, retry, map, catchError, of } from 'rxjs';
import { HomeMeasure, HomeVeluxMeasurePayload, NotificationSettings } from './homes.interface';

@Injectable()
export class HomesServiceVelux {
  constructor(private readonly http: NgrxHttpClient) {
  }

  getHomeNotifications(params): Observable<{ notification_settings: Record<string, { NXG: NotificationSettings }> }> {
    return this.http.get('getnotificationsettings', params);
  }

  setHomeNotifications(params): Observable<void> {
    return this.http.post('setnotificationsettings', params);
  }

  homeMeasures(params: HomeVeluxMeasurePayload): Observable<number[]> {
    return this.http.post('gethomemeasure', params).pipe(
      retry(5),
      map(m => this.parseMeasuresData(m.body.home.modules[0].measures)),
      catchError(() => of([])),
    );
  }

  // Parse the datas returned from the getMeasure function
  private parseMeasuresData(measures: HomeMeasure[]): number[] {
    const values: number[] = [];

    for (const measure of measures) {
      const tabs = measure.value;
      for (const tab of tabs) {
        values.push(tab[0]);
      }
    }
    return values;
  }
}
